import Header from "../components/Header"
import "../Myprojects.css"
import OverviewTr from "./OverviewTr"
import DetailsTr from "./DetailsTr"
import ResouresTr from "./ResourcesTr"
import Model3d from "./Model3d"
import React, { useState,useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import api from "views/auth/Api";
import { API_BASE_URL } from '../../../../configs/AppConfig';

const ProjectMainTr = () => {
const [data , setData] = useState([]);
const [current , setCurrent] = useState("overview");
const [title , setTitle] = useState("");
const [subject , setSubject] = useState("");
const [proId , setProId] = useState("");
const { id } = useParams();
const [isActive, setIsActive] = useState("");
const [loading, setLoading] = useState(false);
const navigate = useNavigate();

       useEffect(() => {
       api.get(`${API_BASE_URL}projects/${id}`)
        .then((response) => {  
          if (!response.data) {
            navigate(`/auth/not-found/`);
          }
          setData(response.data);
          setTitle(response.data?.projectName);
          setProId(response.data?.id);
          setSubject(response.data?.subject);
          setIsActive(response.data?.isActive);
          setLoading(true);
        })
        .catch((error) => {
          console.error('Error fetching card:', error);
        });
    }, [navigate,id]);


  const change = (page) => {
          setCurrent(page);
        }
  const action = (status) => {
    setIsActive(status);
  }
  return (
    <div>
      <Header current = {current} change ={change} title={title} subject={subject} proId={proId} active={isActive} action={action} isloading={loading} />
     {current ==="overview" ? <OverviewTr data={data} /> : null }
     {current ==="details" ? <DetailsTr data={data} /> : null }
     {current ==="resources" ? <ResouresTr data={data}/> : null }
     {current ==="model3d" ? <Model3d data={data}/> : null }
     {/* {current ==="subFeed" ? <SubmissionFeedback data={data}/> : null } */}
    </div>
  );
};

export default ProjectMainTr;
